import { forwardRef, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useFormContext, Controller } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";
import { Button, Label, TextArea } from "abs-ui-components";

import "./C213BallastVoyagesFuelConsumption.scss"

import { AUTOSAVE_SUCCESS_MESSAGE, cSectionFormFields } from "../../Constants";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";

const C213BallastVoyagesFuelConsumption = forwardRef(({ c213FuelConsumptionOnBallast, vesselMstId,refetchMonitoringData }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    const { dirtyFields } = formState;
    const isC213Dirty = !!(dirtyFields?.c213 && Object.keys(dirtyFields.c213).length > 0);

    useEffect(() => {
        if (c213FuelConsumptionOnBallast) {
            reset(prev => ({ ...prev, c213: c213FuelConsumptionOnBallast }));
        }
    }, [c213FuelConsumptionOnBallast, reset]);

    AutoSave(ref, [], async () => {
        if (!isC213Dirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("c213");
        const payload = {
            ...cSectionFormFields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const c213BallastVoyagesFuelConsumption = await callApi({
                method: "POST",
                url: API_ROUTES.C213(vesselMstId),
                data: payload,
            });
            if (c213BallastVoyagesFuelConsumption?.isSuccess) {
                emitToasterMsg("success", "Table C.2.13", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, c213: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table C.2.13", c213BallastVoyagesFuelConsumption?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table C.2.13", error.errorMessage);
        }
    };

    return (
        <div className="c213-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">Determining and recording the fuel consumption on ballast voyages</h6>
                </MDBCol>
            </MDBRow>
            {cSectionFormFields?.map(({ label, name, maxLength }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`c213.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`c213_${name}`}
                                    className="textarea-resize"
                                    value={field?.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="c213_save_btn"
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                    disabled={!isC213Dirty}
                >Save</Button>
            </div>
        </div>
    );
});

export default C213BallastVoyagesFuelConsumption;